module.exports = __webpack_public_path__ + "img/厨房.0bdca5fb.webp";